"use strict";

var _slicedToArray = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = exports.addResizeCallback = exports.WindowSizeProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var WindowSizeContext = (0, _react.createContext)({
  windowSize: {}
});

var getWindowSize = function getWindowSize() {
  if (typeof window === 'object') {
    var _window = window,
        height = _window.innerHeight,
        width = _window.innerWidth;
    return {
      width: width,
      height: height
    };
  }

  return {
    width: 0,
    height: 0
  };
};

var addResizeCallback = function addResizeCallback(func) {};

exports.addResizeCallback = addResizeCallback;

var WindowSizeProvider = function WindowSizeProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _react.useState)(getWindowSize()),
      _ref3 = _slicedToArray(_ref2, 2),
      windowSize = _ref3[0],
      setWindowSize = _ref3[1];

  (0, _react.useEffect)(function () {
    setWindowSize(getWindowSize());

    var handleWindowSize = function handleWindowSize() {
      setWindowSize(getWindowSize());
    };

    window.addEventListener('resize', handleWindowSize);
    return function () {
      return window.removeEventListener('resize', handleWindowSize);
    };
  }, []);

  var addResizeCallback = function addResizeCallback(callback) {
    typeof window === 'object' && window.addEventListener('resize', callback);

    var cleanup = function cleanup() {
      typeof window === 'object' && window.removeEventListener('resize', callback);
    };

    return cleanup;
  };

  return _react.default.createElement(WindowSizeContext.Provider, {
    value: {
      windowSize: windowSize,
      addResizeCallback: addResizeCallback
    }
  }, children);
};

exports.WindowSizeProvider = WindowSizeProvider;

var useWindowSize = function useWindowSize() {
  return (0, _react.useContext)(WindowSizeContext);
};

exports.useWindowSize = useWindowSize;